<script>
    import wrappedFetch from "../../wrappedFetch.js";
    import Spinner from "../components/spinner.svelte";
    import Logs from "../components/logs.svelte";
    import Modal from "../components/modal.svelte";
    import DataTable from "../../components/data-table.svelte";
    import { onMount } from "svelte";
    import NoDataFound from "../components/nodatainfo.svelte";

    let logNumbers;
    let history=[];
    let isPageLoading = true;
    let isHistoryLoading = false;
    let showHistory=false;
    const getLogNumbers = async()=>{
        isPageLoading = true;
        let resp = await wrappedFetch("/api/reports/getLogStatistics",{ method: "post",});
        logNumbers=(await resp.json()).response;
        isPageLoading = false;
    }

    const getImportHistory = async()=>{ 
        isHistoryLoading = true;
        showHistory = true;
        let resp = await wrappedFetch("/api/import/GetImportHistory",{ method: "post",});
        history=(await resp.json());
        isHistoryLoading = false;
    }

    onMount(async()=> {
        await getLogNumbers()
        //await getImportHistory()
    });
</script>
<svelte:head>
<title>Import Logs | Wavenet Nimbus </title>
</svelte:head>
{#if isPageLoading}
  <Spinner/>
{:else}
{#if logNumbers == null}
<h3>Import Logs</h3>
<NoDataFound infoText={"No Data Found"}>
 <p>Please ensure the configuration has been completed and data has been imported.Please click the 'Configuration' button below to view the settings.</p>
 <a class="btn btn-primary" href="/app/import/summary">Configuration</a>
</NoDataFound>
{:else}
<Logs pupilLogsURL="/app/import/logs/pupil" staffLogsURL="/app/import/logs/staff" staffPendingrequestURL="/app/import/logs/staffpendingrequests" params={logNumbers} parentComponent={"import"}>
    <div slot="header">
        <h1>Import Logs</h1>
    <p style="margin-bottom:0.5rem;">Last import: {logNumbers.processedDate}</p>
    <div style="margin-bottom:1rem;">
        <button class="btn btn-primary" on:click={()=>getImportHistory()}>Import History</button>
        </div>
    </div>   
    </Logs>
{/if}
{/if}
{#if showHistory}
<Modal bind:showModal ={showHistory} sizeClass={""} showFooter={false} >
<div slot="header"><h4>Import History</h4></div>
<div slot="content">
    {#if isHistoryLoading}
    <Spinner/>
    {:else}
    <DataTable DataLength={history.length}  isFixedHeight={true} columnDefs={[{"targets":0, "type":"date-euro"}]} order={[[0, "desc"]]} message="There are no records for this Establishment.">
        <thead>
            <tr>                    
            <th>Import Time</th>                                 
            <th>Report</th>              
            </tr>
        </thead>
        <tbody>
            {#each history as h}
            <tr>
                <td>{h.uploadTimeStr || ''}</td>
           <td>{#if h.isCloud } {h.reportNameCloud} {:else} {h.reportName}{/if}</td>  
            </tr>
            {/each}
        </tbody>
    </DataTable>
    {/if}
</div>
</Modal>
{/if}